export default __webpack_public_path__ + "static/media/pizza-3.02439a85.jpg";